module.exports = __webpack_public_path__ + "media/images/prediction/special/move/img_link_icon_move-00a9c3478e8b0b6ba38cf4559a5939a5.jpg";